export default function whatsAppService(state = [], action) {
    switch (action.type) {
        case 'GET_WHATSAPP_SERVICE' :
            return {...state, ...action.data, apiLoaded: true};
        case 'REGISTER_WHATSAPP':
            return {...state, registerStatus: action.data}
        case 'REGISTER_DISTRIBUTOR_WHATSAPP':
            return {...state, registerDisStatus: action.data}
        case 'GET_WHATSAPP_SERVICE_TOKEN':
            return {...state, token: action.data}
            case 'GET_WHATSAPP_SERVICE_META':
                return {...state, whatsappmeta: action.data}
        default:
            return state;
    }
}
